export const SwToMainBroadcastMessageTypes = {
    ACTIVATION: 'ACTIVATION',
    CHUNK_REQUEST: 'CHUNK_REQUEST',
    PONG: 'PONG',
    STREAM_REQUEST: 'STREAM_REQUEST',
};
export const MainToSwBroadcastMessageTypes = {
    CHUNK: 'CHUNK',
    ERROR: 'ERROR',
    PING: 'PING',
};
export const FilePreviewContentToMainBroadcastMessageTypes = {
    CAN_PLAY: 'CAN_PLAY',
};
